import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SurveyPage from "./pages/SurveyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SurveyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            borderRadius: 14,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
